module.exports = __webpack_public_path__ + "static/media/onespan.3e20b0f5.jpeg";